export class Template {
  constructor(
    public partnerId: string,
    public siteId: string,
    public domain: string,
    public title: string,
    public screenshotUrl: string,
    public created: Date,
    public templateVersion: number,
    public isTemplateDistributed = false,
  ) {}
}

export interface TemplateMessageInterface {
  partner_id: string;
  site_id: string;
  primary_domain: string;
  title: string;
  screenshot_url: string;
  created: string;
  template_version: number;
  is_template_distributed: boolean;
}

export class TemplateMessage {
  constructor(
    public site_id: string,
    public primary_domain: string,
    public title: string,
    public screenshot_url: string,
    public created: Date,
  ) {}

  public static fromApi(data: TemplateMessageInterface): Template {
    return new Template(
      data.partner_id,
      data.site_id,
      data.primary_domain,
      data.title,
      data.screenshot_url,
      new Date(data.created),
      data.template_version,
      data.is_template_distributed ?? false,
    );
  }
}

export interface TemplateLookupApiMessage {
  partner_ids: string[];
  include_unpublished: boolean;
  cursor: string;
  creating: boolean;
}

export class TemplateLookupMessage {
  constructor(
    public partnerIds: string[],
    public includeUnpublished: boolean,
    public cursor: string,
    public creating: boolean,
  ) {}

  toApiMessage(): TemplateLookupApiMessage {
    return {
      partner_ids: this.partnerIds,
      include_unpublished: this.includeUnpublished,
      cursor: this.cursor,
      creating: this.creating,
    };
  }
}

export interface TemplateLookupResponseData {
  data: {
    templates: TemplateMessageInterface[];
    cursor_string: string;
  };
}

export interface TemplateLookupResponse {
  templates: Template[];
  cursor: string;
}

export interface PublishTemplateResponseData {
  data: PublishTemplateResponseDataFields;
}

export interface PublishTemplateResponseDataFields {
  job_id: string;
  site_id: string;
}

export interface PublishTemplateResponse {
  siteId: string;
  jobId: string;
}

export interface CreateTemplateApiMessage {
  title: string;
  sub_domain: string;
  partner_id: string;
  parent_template_id: string;
}

export class CreateTemplateMessage {
  constructor(
    public title: string,
    public subDomain: string,
    public partnerId: string,
    public parentTemplateId: string,
  ) {}

  toApiMessage(): CreateTemplateApiMessage {
    return {
      title: this.title,
      sub_domain: this.subDomain,
      partner_id: this.partnerId,
      parent_template_id: this.parentTemplateId,
    };
  }
}

export interface CreateTemplateResponseData {
  data: CreateTemplateResponseDataFields;
}

export interface CreateTemplateResponseDataFields {
  template_id: string;
  job_id: string;
}

export interface CreateTemplateResponse {
  templateId: string;
  jobId: string;
}

export interface DeleteTemplateResponse {
  siteId: string;
  jobId: string;
}

export interface DeleteTemplateResponseData {
  data: DeleteTemplateResponseDataFields;
}

export interface DeleteTemplateResponseDataFields {
  site_id: string;
  job_id: string;
}
